<template>
  <button
    :class="['start_button', { 'standard-pass': isStandard }]"
    :disabled="disabled"
    @click="handleClick"
  >
    {{ buttonLabel }}
  </button>
</template>

<script>
export default {
  name: "FaceStartButton",
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: null,
    },
    isStandard: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("clicked");
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  position: absolute;
  bottom: 25%;
  width: 95%;
  height: 50px;
  border: none;
  border-radius: 30px;
  background-color: #ffb206;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}

button.standard-pass {
  position: relative;
  bottom: auto;
  width: 90%;
  margin: 16px auto 0;
  display: block;
}

button:disabled {
  background-color: gray;
}
</style>
